import type { AllowedProductProfileDto } from "../../types/AllowedProductProfileDto";
import type { AllowedProductProfileEntity } from "../../types/AllowedProductProfileEntity";

export const AllowedProductProfileEntityToDto = ({ ...rest }: Readonly<AllowedProductProfileEntity>): AllowedProductProfileDto => {
    return { ...rest };
};
